<template>
  <v-layout>
    <v-flex class="mt-2">
      <v-speed-dial :hover="hover" :direction="direction">
        <v-btn slot="activator" color="blue darken-2" dark hover>
          <v-icon class="mr-1">date_range</v-icon>
          {{ $t('Button.Date_Range_Shortcuts') }}
        </v-btn>
        <v-btn style="z-index:5; margin:2px;" color="secondary" v-for="range in Object.keys(dateRangeShortcuts)" v-on:click="setNewDateRange(range)" :key="range">{{range}}</v-btn>
      </v-speed-dial>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    props: {
      direction: {
        type: String,
        default: 'bottom',
      },
      minDateBound: {
        type: String, // YYYY-MM-DD
      },
      maxDateBound: {
        type: String, // YYYY-MM-DD
      },
      dateRangeShortcuts: {
        type: Object,
      },
    },
    data() {
      return {
        customPast: '',
        customRules: [
          (v) => /^\d+$/.test(v) || 'Custom past must be numerical',
        ],
        hover: false,
      }
    },
    computed: {},
    watch: {},
    methods: {
      setNewDateRange: function(presetName) {
        this.$emit('input', presetName)
      },
    },
  }
</script>